import React from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import classnames from 'classnames'

import LoadingComponent from '../../../LoadingComponent'
import Icon from '../../../util/Icon'

import DropdownMenu from '../../../navigation/DropdownMenu'
import OrderableTH from '../../../navigation/OrderableTH'
import StorePagination from '../../../navigation/StorePagination'

import { append } from '../../../../utils/url'
import { formatDate } from '../../../../utils/format'
import ConfirmationBox from '../../../util/ConfirmationBox'

@inject('leads', 'users', 'auth', 'websites')
@observer
export default class WebsiteLeads extends LoadingComponent {
  state = {
    registered: 'true',
    search: '',
    order_by: 'created_at',
    order_dir: 'desc',
    all_leads: true,
    member_id: null,
    selectedLeads: [],
    showDeleteModal: false
  }

  getUrlQuery = () => {
    const { registered, search, order_by, order_dir, all_leads, member_id } = this.state
    return { registered, search, order_by, order_dir, all_leads, member_id }
  }

  hasLoaded() {
    return this.props.leads.loaded
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    const pageToLoad = this.state.search ? 1 : (nextPage || page)
    this.props.leads.loadPage(pageToLoad, this.getUrlQuery())
  }

  componentWillMount() {
    const { registered='true', search='', order_by='created_at', order_dir='desc' } = this.props.location.query

    this.setState({ registered, search, order_by, order_dir }, () => this.loadPage())
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  componentDidUpdate() {
    if (typeof(this.searchField) !== 'undefined') {
      this.searchField.focus()
    }
  }

  handleSearch = ({ target: { value:search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  handleRegistered = ({ target: { value:registered } }) => {
    this.setState({ registered }, () => this.loadPage())
  }

  handleAllLeads = ({ target: { value: all_leads } }) => {
    if (all_leads === "true" || all_leads == "false") {
      this.setState({ all_leads, member_id: null }, () => this.loadPage())
    } else {
      this.setState({ member_id: all_leads,all_leads: null }, () => this.loadPage())
    }
  };

  getAssignedTo(lead) {
    const user = this.props.users.findById(lead.assigned_to_id)
    return user ? user.name : 'Unassigned'
  }

  deleteHandlerFor = lead => event => {
    event.preventDefault()
    const confirmed = window.confirm(`Really delete the ${lead.name}? They will lose their account and this cannot be undone.`)
    if (!confirmed) {
      return
    }
    this.props.leads.delete(lead.id)
  }

  handleExportCSV = event => {
    event.preventDefault()
    this.props.websites.export_leads().then(resp => {
      const { sending_to } = resp.data
      alert(`CSV will be sent to ${sending_to} after being processed. This may take a few minutes.`)
    }).catch(() => {
      alert(`Failed to generate CSV.`)
    })
  }

  handleSelectAll = (event) => {
    const { checked } = event.target
    const scrollPosition = window.scrollY
    if (checked) {
      const allLeadIds = this.props.leads.records.map(lead => lead)
      this.setState({ selectedLeads: allLeadIds }, () => {
        window.scrollTo(0, scrollPosition)
      })
    } else {
      this.setState({ selectedLeads: [] }, () => {
        window.scrollTo(0, scrollPosition)
      })
    }
  }

  handleSelectLead = (leadId) => (event) => {
    if(this.state.selectedLeads.length === 20 && event.target.checked) {
      alert('You can only select up to 20 leads at a time')
      return
    }
    const { checked } = event.target
    const scrollPosition = window.scrollY
    this.setState(prevState => {
      if (checked) {
        return { selectedLeads: [...prevState.selectedLeads, leadId] }
      } else {
        return { selectedLeads: prevState.selectedLeads.filter(id => id.id !== leadId.id) }
      }
    }, () => {
      window.scrollTo(0, scrollPosition)
    })
  }

  openDeleteModal = () => {
    this.setState({ showDeleteModal: true })
  }
  
  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false })
  }

  handleBulkDelete = (event) => {
    event.preventDefault()
    const { selectedLeads } = this.state
    this.props.leads.delete(selectedLeads.map(lead => lead.id))
      .then(() => {
        this.setState({ selectedLeads: [], showDeleteModal: false, deleteConfirmInput: '' })
        this.loadPage()
      })
      .catch(() => {
        alert('Failed to delete leads. Please try again.')
      })
  }

  renderLoaded() {
    const { search, all_leads, selectedLeads } = this.state
    const { state:{ highlight }={} } = this.props.location
    const urlQuery = this.getUrlQuery()

    return (
      <div className="container padded leads">
        <div className="panel full padded">
          <h2 className="title">Leads</h2>
          <div className="table-actions">
            <input type="search" placeholder="Search Leads..." title="Search by name or email" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }} />

            {this.props.auth.user.admin && (
              <span>
                <label htmlFor="ownership">Assigned To:</label>
                <select
                  id="ownership"
                  value={all_leads}
                  onChange={this.handleAllLeads}
                >
                  <option value="false">Me</option>
                  {this.props.users.records &&
                    this.props.users.records
                      .filter((user) => user.id !== this.props.auth.user.id)
                      .map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.name}
                        </option>
                      ))}
                  <option value="true">Everyone</option>
                </select>
              </span>
            )}

            {selectedLeads.length > 0 && (
              <a className="button danger" onClick={this.openDeleteModal}>
                Delete Selected ({selectedLeads.length})
              </a>
            )}
            <a className="button" onClick={this.handleExportCSV}>Export CSV</a>
            <Link className="button" to={append('invite')}>Create a Lead</Link>
          </div>

          <table className="zebra">
            <thead>
              <tr>
                <th style={{paddingLeft:"0px"}}>
                  <input 
                    type="checkbox" 
                    checked={selectedLeads.length === this.props.leads.records.length}
                    onChange={this.handleSelectAll}
                  />
                  <span style={{marginLeft:"5px"}}>Select all</span>
                </th>
                <th></th>
                <OrderableTH query={urlQuery} field="first_name">Name</OrderableTH>
                <OrderableTH query={urlQuery} field="status">Status</OrderableTH>
                <OrderableTH query={urlQuery} field="persona">Persona</OrderableTH>
                <OrderableTH query={urlQuery} field="users.name">Assigned To</OrderableTH>
                <OrderableTH query={urlQuery} field="viewed_listing_count" defaultDesc tooltip="Viewed Listings"><Icon icon="eye"/></OrderableTH>
                <OrderableTH query={urlQuery} field="message_count" defaultDesc tooltip="Messages"><Icon icon="envelope-o"/></OrderableTH>
                <OrderableTH query={urlQuery} field="comment_count" defaultDesc tooltip="Comments"><Icon icon="comments-o"/></OrderableTH>
                <OrderableTH query={urlQuery} field="reaction_count" defaultDesc tooltip="Reactions"><Icon icon="smile-o"/></OrderableTH>
                <OrderableTH query={urlQuery} field="saved_listing_count" defaultDesc tooltip="Saved Listings"><Icon icon="star-o"/></OrderableTH>
                <OrderableTH query={urlQuery} field="saved_search_count" defaultDesc tooltip="Subscribed Searches"><Icon icon="search"/></OrderableTH>
                <OrderableTH query={urlQuery} field="created_at">First Seen</OrderableTH>
                <OrderableTH query={urlQuery} field="updated_at">Last Seen</OrderableTH>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="padded">
              {this.props.leads.map(l => {
                const { photo } = l.fullcontact
                const urlForPhoto = photo ? photo : "/images/missing_photo_avatar.png"
                return <tr key={l.id} className={classnames({ highlight: highlight === l.id })}>
                  <td>
                      <input
                        type="checkbox"
                        checked={
                          selectedLeads.findIndex((lead) => lead.id === l.id) >
                          -1
                        }
                        onChange={this.handleSelectLead(l)}
                      />
                    </td>
                  <td><img className={"listLeadPhotoContainer"} src={urlForPhoto} /></td>
                  <td>
                    <div className={"listLeadNameContainer"}><Link to={append(l.id)}>{l.name || l.email || "Visitor"}</Link></div>
                    <div className="muted">{l.name && l.email}</div>
                    <div className="muted">{l.phone}</div>
                  </td>
                  <td className="center">{l.status}</td>
                  <td className="center">{l.persona}</td>
                  <td className="center">{this.getAssignedTo(l)}</td>
                  <td className="center">{l.viewed_listing_count}</td>
                  <td className="center">{l.message_count}</td>
                  <td className="center">{l.comment_count}</td>
                  <td className="center">{l.reaction_count}</td>
                  <td className="center">{l.saved_listing_count}</td>
                  <td className="center">{l.saved_search_count}</td>
                  <td className="center">{formatDate(l.created_at)}</td>
                  <td className="center">{formatDate(l.updated_at)}</td>
                  <td className="center">
                    <DropdownMenu menuClass="website-page-actions" menuTitle={<Icon icon="bars" />}>
                      <Link to={append(`${l.id}`)}>Details</Link>
                      <a className="danger" href="#" onClick={this.deleteHandlerFor(l)}>Delete</a>
                    </DropdownMenu>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
          {this.state.showDeleteModal && (
            <ConfirmationBox
              heading={"Permanently Delete Selected Leads"}
              text={`You are about to delete one or more of the following leads.`}
              subText={`${this.state.selectedLeads
                .map((lead) => lead.name)
                .reduce((prev, curr, idx, arr) =>
                  idx === 0
                    ? curr
                    : idx === arr.length - 1
                    ? `${prev} and ${curr}`
                    : `${prev}, ${curr}`
                )}`}
              markup={
                <div>
                  <ul>
                    {this.state.selectedLeads.map((lead) => (
                      <li key={lead.id}>
                        {lead.name}
                      </li>
                    ))}
                  </ul>
                  This operation cannot be undone and all associated data, including contact details, interaction, and history, will be lost.
                </div>
              }
              handleBulkDelete={this.handleBulkDelete}
              selectedData={this.state.selectedLeads}
              openDeleteModal={this.openDeleteModal}
              closeDeleteModal={this.closeDeleteModal}
            />
          )}
          <StorePagination store={this.props.leads} query={urlQuery} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Leads/index.js